import { notify } from "../components/ui";
import { t } from "../i18n";
import { useApi } from "./useApi";
import { billingService } from "../services/billing";
import { FaturasResponse } from "../types/billing.types";

/**
 * Abre a fatura em aberto mais recente (GET /billing/faturas).
 * Usado quando a clínica paga por fatura/boleto — não há cartão para
 * atualizar no Portal, o caminho é pagar a própria fatura. Abre na mesma aba:
 * o Safari bloqueia window.open depois de um await.
 */
export const useFaturaEmAberto = () => {
  const faturasApi = useApi<FaturasResponse>();

  const abrirFatura = async () => {
    const result = await faturasApi.request(() => billingService.getFaturas(faturasApi.apiFetch));
    if (!result) return;
    const aberta = result.faturas.find((f) => f.status === "open" && f.url_fatura);
    if (aberta?.url_fatura) {
      window.location.href = aberta.url_fatura;
    } else {
      notify({ tone: "warning", title: t("billing.noOpenInvoice") });
    }
  };

  return { abrirFatura, loading: faturasApi.loading };
};
